import React from 'react';

export const FlagSEIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 500" // Standard 8:5 ratio
    {...props}
  >
    <rect width="800" height="500" fill="#006AA7" rx="2"/> {/* Blue field */}
    {/* Yellow Nordic Cross */}
    {/* Horizontal bar */}
    <rect y="200" width="800" height="100" fill="#FECC00" />
    {/* Vertical bar */}
    <rect x="250" width="100" height="500" fill="#FECC00" />
  </svg>
);